@if (!isAuthenticated) {
  <div id="login-overlay" class="d-flex align-items-center justify-content-center"
     [ngClass]="currentLocation === 'Mersy' ?
            'mersy_background' : currentLocation === 'Rulebook' ? 'rulebook_background' : ''">
    <div class="login-panel text-center">
      <img src="assets/TKE_Logo.svg" class="logo img-fluid" alt="TKE Logo" />
      <div class="bg-tke-gradient color-white lead">
        {{ currentLocation === 'Mersy' ?
        'MERSY' : currentLocation === 'Rulebook' ? 'Rulebook Editor' : ''
        }}
      </div>
      <div class="content-box">
        <h4 class="login-title">Please, use your TK Elevator account to login</h4>
        <button (click)="login()" class="login-button w-100">Login</button>
      </div>
    </div>
  </div>
}

@if (authServiceInitilized && authService.instance.getAllAccounts().length > 0) {
  <div class='full-page-container'>
    <div class='header-menu'>
      <mat-toolbar style="background-color:inherit;">
        <span>
          <a [routerLink]="['/']">
            <img src="../assets/tke-white-80.png" alt="Tke Logo" />
          </a>
        </span>
        @if (defaults.componentTool === componentToolEnum.Rulebook) {
          <stage [hidden]="hideContractMenuItem" [reload]="reload" (stageChanged)="onStageSelectedChanged($event)"></stage>
        }
        @if (defaults.componentTool === componentToolEnum.Rulebook) {
          <tenant [hidden]="hideTenantMenuItem" [isTenDlrCong]="!hideRegulatoryAndDialerItem" (tenantChanged)="onTenantSelectedChanged($event)"></tenant>
        }
        <!--two drop downs (Dialer & Regulatory code )-->
        @if (defaults.componentTool === componentToolEnum.Rulebook && (this.defaults.RegCode.value || !hideRegulatoryAndDialerItem)) {
          <regulatoryanddialer [hidden]="hideRegulatoryAndDialerItem"></regulatoryanddialer>
        }
        <!-- controller-type select -->
        @if (defaults.componentTool === componentToolEnum.Rulebook) {
          <controller-type [isDigitalServiceView]="isDigitalServiceView" [hidden]="hideControllerTypeMenuItem" (controllerChanged)="onControllerTypeSelectedChanged($event)"></controller-type>
        }
        @if (defaults.componentTool === componentToolEnum.Mersy) {
          <managementid [hidden]="hideManagementIdMenuItem" (managementIdChanged)="onManagementIdSelectedChanged($event)"></managementid>
        }
        @if (defaults.componentTool === componentToolEnum.Mersy && router.url !== '/osh-assessment' && !hideWaveItem) {
          <wave-selector></wave-selector>
        }
        @if (defaults.componentTool === componentToolEnum.Mersy && router.url === '/osh-assessment' && !hideWaveItem) {
          <osh-wave-selector></osh-wave-selector>
        }
        <!--Mersy Related-->
        @if (defaults.componentTool === componentToolEnum.Mersy) {
          <fiscalyear [hidden]="hideFiscalYearMenuItem"></fiscalyear>
        }
        @if (defaults.componentTool === componentToolEnum.Mersy) {
          <oplversion [hidden]="hideOplVersionMenuItem"></oplversion>
        }
        @if (defaults.componentTool === componentToolEnum.Mersy) {
          <period [hidden]="hidePeriodMenuItem"></period>
        }
        <!-- language select -->
        <language [hidden]="hideLanguageMenuItem"
        (languageChanged)="onLanguageSelectedChanged($event)"></language>
        @if (defaults.componentTool === componentToolEnum.Rulebook && (this.defaults.healthScorePopulation.value || !hidePopulationMenuItem)) {
          <population [hidden]="hidePopulationMenuItem"></population>
        }
        @if (defaults.componentTool === componentToolEnum.Mersy) {
          <quarter-selector [hidden]="hideQuarterItem"></quarter-selector>
        }
        @if (defaults.componentTool === componentToolEnum.Rulebook) {
          <country [hidden]="hideCountryMenuItem"></country>
        }
        <span style="flex: 1 1 auto;"></span>
        @if (defaults.componentTool === componentToolEnum.Mersy) {
          <span>
            <a target="_blank" href="https://tke.service-now.com/tkeserviceportal?id=report_an_issue" [matTooltip]="'Create a Ticket / Report a Bug'">
              <mat-icon class="wiki_icon" style="margin-right: 0.5rem !important">
                flag_circle
              </mat-icon>
            </a>
          </span>
        }
        <span>
          <a [matTooltip]="isWikiBtnDisabled ? 'Inline Documentation not Available' : 'Inline Documentation'" (click)="onInlineDocClick()">
                    <mat-icon [ngStyle]="{color: isWikiBtnDisabled ?
                                '#494949' : hideInlineDoc ? '#a31aff' : '#ffffff'}"
              [ngClass]="isWikiBtnDisabled ? 'non-clickable-icon' :  'clickable_icon'" class="wiki_icon">
              {{isWikiBtnDisabled ? 'info-icon' : hideInlineDoc ? 'info-icon':'info-icon_off' }}
            </mat-icon>
            @if (showWikiLoadBar) {
              <mat-progress-bar class="wikiPrgressBar" mode="indeterminate" style=" width: 54%; bottom: 6px;"></mat-progress-bar>
            }
          </a>
        </span>
        <nav-menu-tools [hideOwnerMenuItem]="hideOwnerMenuItem" [userUPN]="currentUser" [isControllerOwner]="isControllerOwner"></nav-menu-tools>
      </mat-toolbar>
    </div>
    <sidenav-menu style="float:left;"></sidenav-menu>
    <div id="main-content" #maincontent [ngStyle]="{'background-image':
        router.url === '/' && defaults.componentTool === componentToolEnum.Mersy ? 'url(../assets/mersy_background.jpg)':
            router.url === '/' && defaults.componentTool === componentToolEnum.Rulebook ? 'url(../assets/rulebook_background.jpg)' : ''}">
      <div class='container-fluid' style=" position: relative; ">
        <div class='main-container' [ngClass]="waiting.classopacity">
          <div [ngClass]="dialog.classname!">
            <router-outlet></router-outlet>
          </div>
        </div>
        <alert-confirm [message]="dialog.message!"
          [messageColor]="dialog.messageColor!"
          [messageFontSize]="dialog.messageFontSize!"
          [title]="dialog.title!"
          [className]="dialog.classdialog!"
          [type]="dialog.type!"
          [items]="dialog.items!"
          [showTypeIcon]="dialog.showTypeIcon"
          [progressValue]="dialog.progressValue!"
          [text_icon_items]="dialog.text_icon_items"
          (clickOk)="dialog.onOk()"
          (clickNo)="dialog.onNo()"
          (clickYes)="dialog.onYes()">
        </alert-confirm>
        <wikinav (disableWikiBtn)="receiveWikiAvBool($event)" (showLoadingBar)="receiveWikiLdBarBool($event)" [hideInlineDoc]="hideInlineDoc"></wikinav>
      </div>
    </div>
    <div class="footer-menu">
      <div class='container-fluid' style=" position: relative; ">
        <a href="/legal/cookie-policy.html" target="_blank" rel="noopener noreferrer">Cookies Policy</a>
        |
        <a href="/legal/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        |
        TK Elevator &copy; {{ currentYear }} All rights reserved.
      </div>
    </div>
  </div>
}
